var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenMarkerMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.3 132.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #34a853;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.27,36.08s0-.08,0-.11c-.33-1.7-.87-3.44-1.49-5.11-.73-2.07-1.58-4.08-2.57-6.01l-.07.09s0,0,0,0c.02-.03.05-.06.07-.09-.78-1.5-1.64-2.94-2.57-4.34-.04-.07-.07-.11-.07-.11h0c-5.77-8.59-14.32-15.08-24.36-18.25h0C55.8.75,51-.05,46.1-.05,32-.05,19.3,6.35,10.8,16.45,4.1,24.45,0,34.85,0,46.05c0,8.7,1.7,15.7,4.6,22,4.41,9.75,11.54,17.81,19.03,27.37l3.73,4.9c2.04,2.8,4.12,5.83,6.13,8.93,9.4,14.5,6.8,23.1,12.8,23.1s3.4-8.7,12.8-23.2h0c15.4-24.1,33.3-35,33.3-63,0-3.47-.4-6.83-1.13-10.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMarkerMap);
export default __webpack_public_path__ + "static/media/green_marker_map.623145095850a86c0a648faa401305e0.svg";
export { ForwardRef as ReactComponent };